export default __webpack_public_path__ + "static/broadcastImg4-2a250d9ec839d3a07a1a69941a406192.webp";